module.exports = __webpack_public_path__ + "img/19_b.d83bcdc3.jpg";